// tslint:disable
export enum PharmacyCoverageType {
    /**
     * @description Retail
     */
    RTL = 1,
    /**
     * @description Mail Order
     */
    MOD = 2,
    /**
     * @description Long Term Care
     */
    LTC = 3,
    /**
     * @description Specialty
     */
    Specialty = 4,
}
(PharmacyCoverageType as any)['SPECIALTY'] = 4;
